<template>
    <div class="email-templates">
        <div v-if="!editMode">
            <!-- Şablon listesi -->
            <div class="toolbar-container">
                <div class="left-section">
                    <EmailTemplateFilterToolbar v-model="filters" ref="filterToolbar" />
                </div>
                <div class="right-section">
                    <SupsisButton @click="openCreateTemplateModal" primary small>Yeni Şablon</SupsisButton>
                </div>
            </div>

            <supsis-table
                :columns="columns"
                :rows="templates"
                :bottom-pagination="true"
                :pagination-cursor="paginationCursor"
                @cursor-changed="onCursorChanged"
            >
            </supsis-table>

            <Modal2 v-if="showCreateTemplateModal" @cancel="closeCreateTemplateModal" @ok="createTemplate">
                <template #title>Yeni E-posta Şablonu Oluştur</template>
                <CreateEmailTemplateForm ref="createTemplateForm" />
            </Modal2>
        </div>
        
        <div v-else>
            <!-- Şablon editörü -->
            <EmailTemplateEditor :template="selectedTemplate" @close="editMode = false" @template-updated="onTemplateUpdated" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import EmailTemplateFilterToolbar from "./EmailTemplateFilterToolbar.vue";
import { MAIL_API } from "../../../../api/mail";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import CreateEmailTemplateForm from "./CreateEmailTemplateForm.vue";
import EmailTemplateEditor from "./EmailTemplateEditor.vue";

export default Vue.extend({
    name: "EmailTemplates",
    components: { SupsisTable, EmailTemplateFilterToolbar, SupsisButton, Modal2, CreateEmailTemplateForm, EmailTemplateEditor },
    data() {
        return {
            templates: [],
            filters: [],
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            columns: [
                {
                    key: "name",
                    field: "name",
                    title: "Şablon Adı",
                },
                {
                    key: "subject",
                    field: "subject",
                    title: "Konu",
                },
                {
                    key: "category",
                    field: "category",
                    title: "Kategori",
                    renderBodyCell: ({ row }) => {
                        console.log("renderBodyCell", row);
                        const colors = {
                            marketing: "blue",
                            operational: "green",
                            private: "red",
                        };
                        const color = colors[row.category] || "gray";
                        return (
                            <span class="category-chip" style={{ backgroundColor: color }}>
                                {row.category}
                            </span>
                        );
                    },
                },
                {
                    key: "creator",
                    field: "creator",
                    title: "Oluşturan",
                    renderBodyCell: ({ row }) => row.creator?.name,
                },
                {
                    key: "createdAt",
                    field: "createdAt",
                    title: "Oluşturulma Tarihi",
                    renderBodyCell: ({ row }) => new Date(row.createdAt).toLocaleDateString(),
                },
                {
                    key: "actions",
                    title: "İşlemler",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="actions d-flex gap-5">
                                <SupsisButton small onClick={() => this.editTemplate(row)}>
                                    Düzenle
                                </SupsisButton>

                                <SupsisButton small type="danger" onClick={() => this.deleteTemplate(row._id)}>
                                    Sil
                                </SupsisButton>
                            </div>
                        );
                    },
                },
            ],
            showCreateTemplateModal: false,
            editMode: false,
            selectedTemplate: null,
        };
    },
    methods: {
        async fetch() {
            const { templates, total } = await MAIL_API.TEMPLATE.listEmailTemplates({
                filters: this.filters,
                ...this.paginationCursor,
            });
            this.templates = templates;
            this.paginationCursor.total = total;
        },
        async onCursorChanged(newCursor) {
            this.paginationCursor = newCursor;
            await this.fetch();
        },
        refreshData() {
            this.fetch();
        },
        editTemplate(template) {
            this.selectedTemplate = template;
            this.editMode = true;
        },
        deleteTemplate(templateId) {
            // Şablon silme işlemi
        },
        openCreateTemplateModal() {
            this.showCreateTemplateModal = true;
        },
        closeCreateTemplateModal() {
            this.showCreateTemplateModal = false;
        },
        async createTemplate() {
            const { name, subject, category } = this.$refs.createTemplateForm.getFormData();
            await MAIL_API.TEMPLATE.createMailTemplate({
                name,
                subject,
                category,
                html: null,
                design: null,
                userId: this.$store.state.auth.user._id,
            });
            this.closeCreateTemplateModal();
            this.fetch();
        },
        onTemplateUpdated(updatedTemplate) {
            const index = this.templates.findIndex(template => template.id === updatedTemplate.id);
            if (index !== -1) {
                this.$set(this.templates, index, updatedTemplate);
            }
        },
    },
    watch: {
        filters: {
            handler() {
                this.paginationCursor.page = 1;
                this.fetch();
            },
            deep: true,
        },
    },
    mounted() {
        this.fetch();
    },
});
</script>

<style scoped lang="scss">
.email-templates {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
}

.category-chip {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 20px;
    color: white;
    font-size: 12px;
    font-weight: bold;
}

.toolbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .left-section {
        flex: 1;
    }

    .right-section {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
